/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const DEFAULT_APP_CONFIG = {
    db: {
        boilerplate: {
            name: "boilerplate.realm",
        },
    },
    servers: {
        graphql: [
            {
                name: "api-gateway",
                url: "https://countries.trevorblades.com",
            },
        ],
        rest: {
            dummyRestServer: {
                baseURL: "http://10.0.1.13:8000",
            },
        },
    },
};
